import { render, staticRenderFns } from "./PostEditImmoOfferG.vue?vue&type=template&id=05a35fb3&"
import script from "./PostEditImmoOfferG.vue?vue&type=script&lang=js&"
export * from "./PostEditImmoOfferG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports